<template>
  <main class="wrapper">
    <div class="container">
      <!-- 이미지 영역 -->
      <div id="imageArea" class="img-card">
        <img v-bind:src="banner_img" alt="login" class="img-banner">
      </div>
      
      <!-- Slot 영역 -->
      <div class="content-area">
        <slot></slot>
      </div>
    </div>
    
    <!-- 하단 푸터 중앙 정렬 -->
    <div class="login-footer text-center">
      © Since 2014 - {{now_year}} by Silicon2. All rights reserved.
    </div>
  </main>
</template>
<script>
  
  export default {
    name: 'wrapper',
    data() {
    return {
      now_year: '',
      banner_img :  "/images/banner_bg.jpg",
    };
  },
  created: function() {
     this.now_year = new Date().getFullYear();
  },

  };
  </script>
  
  <style scoped>
  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center; /* 수평 중앙 정렬 */
    align-items: center; /* 수직 중앙 정렬 */
    min-height: 100vh; /* 화면 전체 높이 기준으로 중앙에 배치 */
    width: 100%;
  }
  
  .container {
    display: flex;
    justify-content: space-between; /* 이미지와 content 사이에 공간을 균등 분배 */
    align-items: center;
    width: 900px; /* 중앙 정렬을 위한 너비 조정 */
    border: 0;
    border-radius: 27.5px;
    box-shadow: 0 10px 30px 0 rgba(172, 168, 168, 0.43);
    padding: 20px;
    gap: 30px;
  }
  
  .img-card {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px; /* 이미지 아래에 여백 추가 */

  }
  .img-banner {
    max-width: 400px; /* 이미지 고정 크기 */
    height: auto;
}

.content-area {
  flex: 1;
}

.login-footer {
  width: 100%;
  text-align: center; /* 텍스트를 중앙으로 정렬 */
}

/* 반응형 처리 */
@media (max-width: 1000px) {
  .container {
    flex-direction: column; /* 화면이 줄어들면 세로로 배치 */
    align-items: center; /* 수평 중앙 정렬 */
    width: 90%;
    min-width: 350px;
    max-width: 400px;
  }

  .img-card {
    margin-bottom: 20px; /* 이미지 아래에 여백 추가 */
  }
  
  .img-banner {
    width: 100%;
    max-width: 360px; /* 이미지 고정 크기 */
    height: auto;
  }

  .content-area {
    padding-left: 0; /* 모바일에서 패딩 제거 */
  }
}
  </style>
  